import React from "react";
import { Button, Checkbox, Popover, Typography } from "@arco-design/web-react";
import { IconSettings } from "@arco-design/web-react/icon";
import { DEFAULT_VISIBLE, STANDARD_COLUMNS, customFieldColumns } from "./contactColumns";

const { Text } = Typography;

// "Columns" button: tick which contact fields show as table columns. Standard
// fields first, then the org's contact custom fields. At least one column stays.
export default function ColumnPicker({ visible, setVisible, customFieldDefs }) {
    const custom = customFieldColumns(customFieldDefs);
    const toggle = (key, on) => {
        const next = on ? [...visible, key] : visible.filter((k) => k !== key);
        if (next.length) setVisible(next);
    };

    const group = (title, cols) => (
        <div style={{ marginBottom: 10 }}>
            <Text type="secondary" style={{ fontSize: 12, display: "block", marginBottom: 4 }}>{title}</Text>
            {cols.map((c) => (
                <div key={c.key} style={{ padding: "2px 0" }}>
                    <Checkbox
                        checked={visible.includes(c.key)}
                        disabled={visible.length === 1 && visible.includes(c.key)}
                        onChange={(on) => toggle(c.key, on)}
                    >
                        {c.title}
                    </Checkbox>
                </div>
            ))}
        </div>
    );

    return (
        <Popover
            trigger="click"
            position="br"
            title="Columns"
            content={
                <div style={{ width: 240, maxHeight: "60vh", overflowY: "auto" }}>
                    {group("Contact", STANDARD_COLUMNS)}
                    {custom.length > 0 && group("Custom fields", custom)}
                    <Button size="mini" type="text" style={{ padding: 0 }} onClick={() => setVisible(DEFAULT_VISIBLE)}>
                        Reset to default
                    </Button>
                </div>
            }
        >
            <Button type="outline" icon={<IconSettings />}>Columns</Button>
        </Popover>
    );
}
